@if (isLoading()) {
  <tui-loader size="l" />
} @else if (error()) {
  <div tuiNotification appearance="warning">Failed to load tags.</div>
} @else {
  <div class="tag-rows">
    @if (isAdding()) {
      <div class="tag-row editing">
        <tui-textfield tuiTextfieldSize="m" class="name-field">
          <input
            tuiInput
            tuiAutoFocus
            placeholder="Tag name"
            [formControl]="nameControl"
            (keydown.enter)="saveNew()"
            (keydown.escape)="cancel()"
          />
        </tui-textfield>
        <span class="actions">
          <button
            tuiButton
            appearance="flat-grayscale"
            size="s"
            type="button"
            (click)="cancel()"
          >
            Cancel
          </button>
          <button
            tuiButton
            appearance="primary"
            size="s"
            iconStart="@tui.check"
            type="button"
            [disabled]="!canSave()"
            (click)="saveNew()"
          >
            Save
          </button>
        </span>
      </div>
    }

    @for (tag of tags(); track tag.id) {
      <div class="tag-row" [class.editing]="editingId() === tag.id">
        @if (editingId() === tag.id) {
          <tui-textfield tuiTextfieldSize="m" class="name-field">
            <input
              tuiInput
              tuiAutoFocus
              placeholder="Tag name"
              [formControl]="nameControl"
              (keydown.enter)="saveEdit(tag)"
              (keydown.escape)="cancel()"
            />
          </tui-textfield>
          <span class="actions">
            <button
              tuiButton
              appearance="flat-grayscale"
              size="s"
              type="button"
              (click)="cancel()"
            >
              Cancel
            </button>
            <button
              tuiButton
              appearance="primary"
              size="s"
              iconStart="@tui.check"
              type="button"
              [disabled]="!canSave()"
              (click)="saveEdit(tag)"
            >
              Save
            </button>
          </span>
        } @else {
          <span class="tag-name">{{ tag.name }}</span>
          <span class="actions">
            <button
              tuiButton
              appearance="flat"
              size="s"
              iconStart="@tui.pencil"
              type="button"
              [disabled]="isBusy()"
              (click)="startEdit(tag)"
            >
              Edit
            </button>
            <button
              tuiButton
              appearance="primary-destructive"
              size="s"
              iconStart="@tui.trash-2"
              type="button"
              [disabled]="isBusy()"
              (click)="onDelete(tag)"
            >
              Delete
            </button>
          </span>
        }
      </div>
    } @empty {
      @if (!isAdding()) {
        <p class="empty">No tags yet.</p>
      }
    }
  </div>

  @if (total() > pageSize) {
    <tui-table-pagination
      [page]="page()"
      [size]="pageSize"
      [total]="total()"
      (paginationChange)="onPagination($event)"
    />
  }
}
